import React, { createContext, useContext, useEffect, useState } from "react";
import { TRANSLATIONS } from "@/data/translations";

const I18nContext = createContext({ lang: "fr", setLang: () => {}, toggleLang: () => {}, t: (k) => k });
const KEY = "pg_lang";

function detectLang() {
  try {
    const saved = localStorage.getItem(KEY);
    if (saved === "fr" || saved === "en") return saved;
  } catch {}
  // Détection auto selon la langue/pays du navigateur
  const langs = (navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language || "fr"]);
  const isEn = langs.some((l) => /^en\b/i.test(l));
  return isEn ? "en" : "fr";
}

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(detectLang);

  useEffect(() => {
    try { localStorage.setItem(KEY, lang); } catch {}
    document.documentElement.setAttribute("lang", lang === "en" ? "en-CA" : "fr-CA");
  }, [lang]);

  const setLang = (l) => setLangState(l);
  const toggleLang = () => setLangState((l) => (l === "fr" ? "en" : "fr"));

  // t("section.key") -> string, repli sur FR puis sur la clé
  const t = (path) => {
    const parts = path.split(".");
    const read = (obj) => parts.reduce((acc, p) => (acc && acc[p] !== undefined ? acc[p] : undefined), obj);
    const val = read(TRANSLATIONS[lang]);
    if (val !== undefined) return val;
    const fr = read(TRANSLATIONS.fr);
    return fr !== undefined ? fr : path;
  };

  return <I18nContext.Provider value={{ lang, setLang, toggleLang, t }}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  return useContext(I18nContext);
}
